import { Box, Typography } from '@mui/material';

import Avatar from '@/modules/common/components/Avatar/Avatar';

export interface Props {
  text: string;
}

const UserNameAvatar = ({ text }: Props) => {
  return (
    <Box display="flex" alignItems="center">
      <Avatar
        styles={{
          width: 30,
          height: 30,
          fontSize: '0.875rem',
        }}
        input={text}
      />
      <Typography variant="subtitle2" sx={{ ml: 1 }}>
        {text}
      </Typography>
    </Box>
  );
};

export default UserNameAvatar;
